<template>
<div class="link-instructions-component">
  <div v-if="!disableTitle">
    <Center class="welcome-banner mb-3" >
      <h1 class="ma-0">
        Connect your App in 2 Easy Steps
      </h1>
    </Center>
    <p class="expl">
      Welcome to PM2.io, an advanced monitoring system for Node.js application and servers.<br/>
      <b>You can now connect up to 4 servers or Node.js processes for free</b>. Try it out:
    </p>
  </div>
  <div v-else>
    <h2 class="mb-3">Connect extra servers:</h2>
  </div>
  <VerticalTabs :tabs="linkInstructions">
    <div slot="Server">
      <ProviderInstructions provider="baremetal" />
    </div>
    <div slot="Docker">
      <ProviderInstructions provider="docker" />
    </div>
    <div slot="AWS">
      <ProviderInstructions provider="ebs" />
    </div>

    <div slot="after-tabs" class="mt-1">
      <a target="_blank" href="http://doc.pm2.io/en/plus/overview/"><KmIcon :size="18" name="km-icon-support" class="ml-2" /> Documentation</a>
    </div>
  </VerticalTabs>
</div>
</template>

<script>
import VerticalTabs from './VerticalTabs'
import ProviderInstructions from './ProviderInstructions'
import KmIcon from '@/components/KmIcon'

export default {
  name: 'LinkInstructions',
  components: {
    VerticalTabs,
    KmIcon,
    ProviderInstructions
  },
  props: ['disableTitle'],
  data() {
    return {
      linkInstructions: [
        {
          name: 'Server',
          default: true,
        },
        {
          name: 'Docker',
        },
        {
          name: 'AWS',
        }
      ],
    }
  },
}
</script>

<style lang="postcss">
.link-instructions-component {
  background-color: var(--contrast);
  width: 1000px;
  margin: 0 auto;
  border-radius: 8px;
  padding: 17px 14px;
  & .expl {
    font-size: 17px;
    text-align: center;
  }
}
</style>
